import { Component, OnInit, ElementRef, TemplateRef,ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SportService } from '../services/sport.service';
import * as moment from 'moment';
import { resolve } from 'q';
import { ToastrService } from 'ngx-toastr';
import { SocketServiceService } from '../services/socket-service.service';
import { LoginService } from '../services/login.service'
import { CookieService } from 'ngx-cookie-service';
import { ReportService } from '../services/report.service';

import { data } from 'jquery';
import { log } from 'console';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [HeaderComponent, SidebarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;
  @ViewChild('autoShowPopup', {static: true}) public autoShowPopup: TemplateRef<any>;
  moment: any = moment;
  homeData: any;
  homeDataFav:any=[]
  public timer: any;
  allSportsList: any;
  modalRef: BsModalRef;
  userData: any;
  firstData: any;
  parameter: any;
  a: any = [];
  runnerData: any;
  combineData: any;
  Data: any;
  finalData: any;
  isSocket;
  runnerDataLength: any;
  firstDataLength: any;
  updateRunnerData: any = [];
  exchangeGameList: any=[
    {
      "name": "6 Poker",
      "code": "BTV-6poker",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/6 Poker_1654237156894.3398.jpg",
      "category": [
          {
              "name": "32 Cards",
              "code": "32 Cards",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/32 Cards_1654777598194.0503.png"
          }
      ]
  },
  {
      "name": "Baccarat",
      "code": "BTV-baccarat",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Baccarat_1654237163452.366.jpg",
      "category": [
          {
              "name": "Baccarat",
              "code": "Baccarat",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Baccarart_1654777579181.7312.png"
          }
      ]
  },
  {
      "name": "Best on Poker",
      "code": "BTV-betonpoker",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Bet on Poker_1654237170103.5703.jpg",
      "category": [
          {
              "name": "Poker",
              "code": "Poker",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Poker_1654777511911.437.png"
          }
      ]
  },
  {
      "name": "Dice Dual",
      "code": "BTV-diceduel",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Dice Duel_1654237178655.1594.jpg",
      "category": [
          {
              "name": "Instant Win",
              "code": "Instant Win",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Instant-Win-games_1654777523405.1008.png"
          }
      ]
  },
  {
      "name": "Lucky 5",
      "code": "BTV-lucky5",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Lucky 5_1654237187638.846.jpg",
      "category": [
          {
              "name": "Lucky 7",
              "code": "UD7",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lucky-7_1657523847464.5024.jpg"
          }
      ]
  },
  {
      "name": "Lucky 6",
      "code": "BTV-lucky6",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Lucky 6_1654237193693.8108.jpg",
      "category": [
          {
              "name": "Lucky 7",
              "code": "UD7",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lucky-7_1657523847464.5024.jpg"
          }
      ]
  },
  {
      "name": "Lucky 7",
      "code": "BTV-lucky7",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Lucky 7_1654237200162.9094.jpg",
      "category": [
          {
              "name": "Lucky 7",
              "code": "UD7",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lucky-7_1657523847464.5024.jpg"
          }
      ]
  },
  {
      "name": "Speedy 7",
      "code": "BTV-speedy7",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Speedy 7_1654237207804.3242.jpg",
      "category": [
          {
              "name": "Lucky 7",
              "code": "UD7",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lucky-7_1657523847464.5024.jpg"
          }
      ]
  },
  {
      "name": "Wars Of Bets",
      "code": "BTV-warofbets",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/War of Bets_1654237215269.644.jpg",
      "category": [
          {
              "name": "Instant Win",
              "code": "Instant Win",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Instant-Win-games_1654777523405.1008.png"
          }
      ]
  },
  {
      "name": "Wheels of Fortune",
      "code": "BTV-wheeloffortune",
      "providerCode": "QT",
      "providerName": "Qtech",
      "thumb": "http://files.worldcasinoonline.com/Document/Game/Wheel of Fortune_1654237220090.2173.jpg",
      "category": [
          {
              "name": "Instant Win",
              "code": "Instant Win",
              "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Instant-Win-games_1654777523405.1008.png"
          }
      ]
  },
  {
    "name": "Balloon",
    "code": "Balloon",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/balloon_1721824523022.0544.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "Cappadocia",
    "code": "Cappadocia",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/Cappadocia_1721824539364.8926.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "Crash Duel X",
    "code": "TugOfWar",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/Crash-duel-X_1721824693948.9705.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "Crazy HuntX",
    "code": "CrazyHuntX",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/crazy-x-hunt_1721822578309.4949.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "CricketX",
    "code": "CricketX",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/cricket-x_1721824552745.9531.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "DoubleX",
    "code": "SlicerX",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/DoubleX_1721824487920.9072.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "Foxy Hot20",
    "code": "FoxyHot20",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/FoxyHot20_1721824802721.0054.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "HelicopterX",
    "code": "HelicopterX",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/Helicopter-X_1721824887969.1038.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "JetX",
    "code": "JetX",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/jetx_1721824568631.6863.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "JetX3",
    "code": "JetX3",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/jetx3_1721824583087.1028.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "JokerBuyBonus",
    "code": "JokerBuyBonus",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/jocker-buy-bonus_1721824600585.014.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "Multi Hot Ways",
    "code": "MultiHotWays",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/Multi-Hot-Ways_1721824920014.3647.png",
    "category": [
        {
            "name": "Sicbo",
            "code": "Sicbo",
            "thumb": null
        }
    ]
},
{
    "name": "Multi Hot5",
    "code": "MultiHot5",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/multihot05_1721824659006.129.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "RussianKeno",
    "code": "RussianKeno",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/russian-keno_1721824945462.405.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "SpinX",
    "code": "SpinX",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/spin-x_1721824959471.7812.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
    "name": "Virtual Burning Roulette",
    "code": "VirtualBurningRoulette",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/Virtual-Burning-Roulette_1721824759613.8645.png",
    "category": [
        {
            "name": "Roulette",
            "code": "Roulette",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Roulette_1654777501811.122.png"
        }
    ]
},
{
    "name": "VirtualRoulette",
    "code": "VirtualRoulette",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/virtual-roulette_1721824775899.1675.png",
    "category": [
        {
            "name": "Roulette",
            "code": "Roulette",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Roulette_1654777501811.122.png"
        }
    ]
},
{
    "name": "Wilds & Gods",
    "code": "WildsAndGods",
    "providerCode": "SMTSG",
    "providerName": "SmartSoft Gaming",
    "thumb": "http://files.worldcasinoonline.com/Document/Game/WildsAndGods_1721824721510.5415.png",
    "category": [
        {
            "name": "Slots",
            "code": "Slots",
            "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
        }
    ]
},
{
  "name": "Aviator",
  "code": "aviator",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Aviator_1733812084754.024.png",
  "category": [
      {
          "name": "Crash Type",
          "code": "Crash Type",
          "thumb": null
      }
  ]
},
{
  "name": "Dice",
  "code": "dice",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Dice_1733812105988.5051.png",
  "category": [
      {
          "name": "TurboGames",
          "code": "TurboGames",
          "thumb": null
      }
  ]
},
{
  "name": "Goal",
  "code": "goal",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Goal_1733812123517.5955.png",
  "category": [
      {
          "name": "Fun",
          "code": "Fun",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Fun-games_1654777536564.067.png"
      }
  ]
},
{
  "name": "Hi Lo",
  "code": "hi-lo",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Hilo_1733813167230.3003.png",
  "category": [
      {
          "name": "TurboGames",
          "code": "TurboGames",
          "thumb": null
      }
  ]
},
{
  "name": "Hotline",
  "code": "hotline",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Hotline_1733813188604.0896.png",
  "category": [
      {
          "name": "FastGames",
          "code": "FastGames",
          "thumb": null
      }
  ]
},
{
  "name": "Keno",
  "code": "keno",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Keno_1733813205276.2085.png",
  "category": [
      {
          "name": "Instant Win",
          "code": "Instant Win",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Instant-Win-games_1654777523405.1008.png"
      }
  ]
},
{
  "name": "Mines",
  "code": "mines",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Mines_1733813220886.858.png",
  "category": [
      {
          "name": "TurboGames",
          "code": "TurboGames",
          "thumb": null
      }
  ]
},
{
  "name": "Mini Roulette",
  "code": "mini-roulette",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/ROULETTE_1733813243606.4597.png",
  "category": [
      {
          "name": "Roulette",
          "code": "Roulette",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Roulette_1654777501811.122.png"
      }
  ]
},
{
  "name": "Plinko",
  "code": "plinko",
  "providerCode": "SPB",
  "providerName": "Spribe",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Plinko_1733813282122.8855.png",
  "category": [
      {
          "name": "Instant Win",
          "code": "Instant Win",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Instant-Win-games_1654777523405.1008.png"
      }
  ]
},
{
  "name": "32 Cards",
  "code": "150010",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/32-Cards_1733923268076.212.png",
  "category": [
      {
          "name": "32 Cards",
          "code": "32 Cards",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/32 Cards_1654777598194.0503.png"
      }
  ]
},
{
  "name": "7 Up Down",
  "code": "900001",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/7-up-&-down_1713530856902.0344.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Amar Akbar Anthony",
  "code": "150014",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Amar-Akbar-Anthony_1733923340169.351.png",
  "category": [
      {
          "name": "32 Cards",
          "code": "32 Cards",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/32 Cards_1654777598194.0503.png"
      }
  ]
},
{
  "name": "Andar Bahar",
  "code": "150007",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Andar-Bahar_1733923202946.5632.png",
  "category": [
      {
          "name": "Andar Bahar",
          "code": "Andar Bahar",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Andar Bahar_1654777589271.4065.png"
      }
  ]
},
{
  "name": "Bacarrat",
  "code": "150002",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Bacarrat_1733923040841.3357.png",
  "category": [
      {
          "name": "Baccarat",
          "code": "Baccarat",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Baccarart_1654777579181.7312.png"
      }
  ]
},
{
  "name": "Baccarat",
  "code": "900009",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Baccarat-2_1713532042328.6135.png",
  "category": [
      {
          "name": "Baccarat",
          "code": "Baccarat",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Baccarart_1654777579181.7312.png"
      }
  ]
},
{
  "name": "Bombing Fishing",
  "code": "600002",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Bombing-Fishing_1713352843114.4312.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Boom Legend",
  "code": "600007",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Boom-Lengend_1713353082576.2188.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Color Prediction",
  "code": "600144",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Color-Prediction_1724224148925.5657.jpg",
  "category": [
      {
          "name": "Instant Win",
          "code": "Instant Win",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Instant-Win-games_1654777523405.1008.png"
      }
  ]
},
{
  "name": "Dinosaur Tycoon",
  "code": "600003",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Dinosaur-Tycoon_1713352913362.5027.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Dragon Fortune",
  "code": "600005",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Dragon-Fortune_1713353000021.2664.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Dragon Tiger",
  "code": "150001",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Dragon-Tiger_1733923005777.5999.png",
  "category": [
      {
          "name": "Dragon Tiger",
          "code": "Dragon Tiger",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Dragon Tiger_1654777559458.6975.png"
      }
  ]
},
{
  "name": "Dragon Tiger",
  "code": "900005",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Dragon-Tiger_1713531863319.108.png",
  "category": [
      {
          "name": "Dragon Tiger",
          "code": "Dragon Tiger",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Dragon Tiger_1654777559458.6975.png"
      }
  ]
},
{
  "name": "DTL",
  "code": "150013",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/DTL_1733923305714.569.png",
  "category": [
      {
          "name": "Dragon Tiger",
          "code": "Dragon Tiger",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Dragon Tiger_1654777559458.6975.png"
      }
  ]
},
{
  "name": "Gem Party",
  "code": "600009",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Gem-Party_1713353151401.0708.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Happy Fishing",
  "code": "600008",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Happy-Fishing_1713353118852.2568.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Hot Chilli",
  "code": "600010",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Hot-Chilli_1713353185370.2383.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Jackpot Fishing",
  "code": "600004",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Jackpot-Fishing_1713352958322.9497.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Jili Lobby",
  "code": "600000",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/JILI-CAISHEN_1724222933787.772.jpg",
  "category": [
      {
          "name": "DcLobby",
          "code": "DcLobby",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lobby (1)_1713531385727.744.png"
      }
  ]
},
{
  "name": "Lucky7",
  "code": "150006",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Lucky-7_1733923170916.04.png",
  "category": [
      {
          "name": "Lucky 7",
          "code": "UD7",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lucky-7_1657523847464.5024.jpg"
      }
  ]
},
{
  "name": "Mega Fishing",
  "code": "600006",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Mega-Fishing_1713353037001.276.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Poker 20-20",
  "code": "150005",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Poker-20-20_1733923135393.6863.png",
  "category": [
      {
          "name": "Poker",
          "code": "Poker",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Poker_1654777511911.437.png"
      }
  ]
},
{
  "name": "Roulette",
  "code": "150004",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Roulette_1733923104598.559.png",
  "category": [
      {
          "name": "Roulette",
          "code": "Roulette",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Roulette_1654777501811.122.png"
      }
  ]
},
{
  "name": "Roulette",
  "code": "900002",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Roullette_1713531670864.3857.png",
  "category": [
      {
          "name": "Roultee",
          "code": "Rou225",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/first deposit (2)_1669440796543.3752.png"
      }
  ]
},
{
  "name": "Royal Fishing",
  "code": "600001",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Royal-Fishing_1713289897520.6191.jpg",
  "category": [
      {
          "name": "Slots",
          "code": "Slots",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Slots_1654777492984.0002.png"
      }
  ]
},
{
  "name": "Royal Gaming Live Lobby",
  "code": "900000",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Royal-Gaming-Lobby_1713531443928.3467.png",
  "category": [
      {
          "name": "DcLobby",
          "code": "DcLobby",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Lobby (1)_1713531385727.744.png"
      }
  ]
},
{
  "name": "Sic Bo",
  "code": "150003",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Sic-Bo_1733923070285.0112.png",
  "category": [
      {
          "name": "Sicbo",
          "code": "Sicbo",
          "thumb": null
      }
  ]
},
{
  "name": "Teen Patti",
  "code": "900004",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Teenpatti_1713531796129.2476.png",
  "category": [
      {
          "name": "Teen Patti",
          "code": "Teen Patti",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Teen Patti_1654777482984.0706.png"
      }
  ]
},
{
  "name": "Teenpatti One Day",
  "code": "150009",
  "providerCode": "DC",
  "providerName": "Dream Casino",
  "thumb": "http://files.worldcasinoonline.com/Document/Game/Teenpatti-One-Day_1733923242168.8013.png",
  "category": [
      {
          "name": "Teen Patti",
          "code": "Teen Patti",
          "thumb": "http://files.worldcasinoonline.com/Document/GameCategory/Teen Patti_1654777482984.0706.png"
      }
  ]
}
  ];
  dataLength: any;
  marketId: any = [];
  callType = 1;
  marketData: any = [];
  socketData: any;
  callingType = 1;
  updateFirstData: any = [];
  token: string;
  operator_id: string;
  games: string;
  adminHeading: string;
  allData: any;
  adminData: any;
  mobileAllSportsList: any;
  sportName : any;
  banner: any;
  userDetail: any;
  totalMatchLength: any;
  iUrl: any;
  casinoItems: boolean;
  constructor(private loginService: LoginService,private modalService: BsModalService,private reportService: ReportService, private cdRef: ChangeDetectorRef, private cookie: CookieService, private socketService: SocketServiceService, private route: ActivatedRoute,
    private head: HeaderComponent, private router: Router, private sport: SportService, private toastr: ToastrService) {
    // this.getAllSportsListData();
    this.getAllSportsList();
    this.exchangeGame();
    // this.openBets();
    this.socketService.onSuccess.subscribe(res => {
      this.socketSuccess(res);
    })
  }
  socketStatus(){
    this.sport.getSocketStatus().subscribe((res) => {
      this.isSocket = res.is_socket;
        this.socketService.setUpSocketConnection();
        this.socketListenersUser();
        this.socketError();
        this.route.params.subscribe(params => {
          if (params.sportName == undefined) {
            this.casinoItems = true;
            this.userData = {};
            this.parameter = 'Cricket';
            this.sportName = 'Cricket';
            this.homematches();
            this.cdRef.detectChanges();
          } else {
            this.parameter = params.sportName;
            this.sportName = params.sportName; 
            if(this.sportName == 'All'){
              this.casinoItems = true;
              this.parameter = 'Cricket';
              this.sportName = 'Cricket';
            } else {
              this.casinoItems = true;
            }
            this.homematches();
            this.cdRef.detectChanges();
            //  this.getHomeMatchCallEvent(this.parameter)
          }
    
        })
    })
  }
  async ngOnInit() {
    this.userDetail = JSON.parse(localStorage.getItem('userDetails'))
    if(localStorage.getItem('showAutoPopup') == 'true'){
      this.openModalAutoShowPopup(this.autoShowPopup)
    }
    
    this.banner = JSON.parse(localStorage.getItem('Banner'))
    window.scrollTo(0,0)
    this.getNews();
  }

  openModalAutoShowPopup(autoShowPopup: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      autoShowPopup,
      Object.assign({}, { class: 'show-popup modal-lg',ignoreBackdropClick: true}),
    );
    localStorage.setItem('showAutoPopup', 'false');
  }

  exchangeGame() {
    let data = {
      sport_id: "-100"
    };
    this.sport.getHomeMatchesList(data).subscribe((res) => {
      if (res.status == true) {
       // this.exchangeGameList = res.data
      }
    })
  }

  socketOnEvent(eventName, callback) {
    this.socketService.socket.on(eventName, data => callback(data));
  }

  socketEmitEvent(eventName, data) {
    this.socketService.socket.emit(eventName, data);
  }
  socketError() {
    this.socketService.socket.on(`error`, (res) => {
      if (res.status == false) {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }
  socketSuccess(res) {
    // this.socketService.socket.on('success', (res) => {
    if (res.status == true) {
      debugger
      if (res.event_code == "subscribe_event") {
        this.marketData = [];
        for (let i = 0; i < this.marketId.length; i++) {
          this.socketOnEvent(this.marketId[i], result => {
            if (result.status == true) {
              this.marketData = result.data;
              this.runnerDataLength = this.marketData.length;
              this.runnerData = this.marketData;
              for (let i = 0; i < this.firstData.length; i++) {
                if (this.firstData[i].marketId == this.runnerData.marketId) {
                  this.firstData[i].runners = this.runnerData.runners;
                  this.firstData[i].status = this.runnerData.status;
                  this.firstData[i].inplay = this.runnerData.inplay;
                  this.socketData = this.firstData[i]
                  break
                }
              }
              // for (let i = 0; i < (this.homeData).length; i++) {
              //   if ((this.homeData)[i] == this.socketData.sport_name) {
              //     let key = Object.values(this.homeData)[i];
              //     for (let l = 0; l < Object.keys(key).length; l++) {
              //       if (key[l].marketId == this.socketData.marketId) {
              //         key[l].runners = this.socketData.runners;
              //         key[l].status = this.socketData.status;
              //         key[l].inplay = this.socketData.inplay;
              //       }
              //     }
              //   }
              // }
              for(let i=0 ; i< this.homeData.length; i++){
                if(this.homeData[i].marketId == this.socketData.marketId){
                  this.homeData[i].runners = this.socketData.runners;
                  this.homeData[i].status = this.socketData.status;
                  this.homeData[i].inplay = this.socketData.inplay;
                }
              }
              this.cdRef.detectChanges();
            }
          })
        }
      } else {
       this.toastr.success(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
      }
    }
    // })
  }
  getRunnerEmit() {
    this.marketId = [];
    for (let i = 0; i < this.firstData.length; i++) {
      this.marketId.push(this.firstData[i].marketId)
    }
    let event = {
      "eventIds": this.marketId
    }
    this.socketEmitEvent('subscribe_event', event);
  }

  marketAdded() {
    this.userData = {};
    this.socketEmitEvent('new_market_added', this.userData);
  }
  
  multi() {
    this.router.navigate(['multiMarket'])
  }
  inplay() {
    this.router.navigate(['inplay'])
  }
  ngOnDestroy() {
    this.socketService.socket.close();
  }
  socketListenersUser() {
    this.socketOnEvent(`homeMatches`, res => {
      // try {
      // if (res.status) {
      this.firstData = res.data;
      this.firstDataLength = this.firstData.length
      for (let i = 0; i < this.firstData.length; i++) {
        this.marketId.push(this.firstData[i].marketId)
      }
      this.getRunnerEmit();
      // }
      // } catch (e) {
      //   this.homematches()
      // }
    });

    this.socketOnEvent(`subscribe_event`, res => {
    });
    this.socketOnEvent(`unsubscribe_event`, res => {
    });
    this.socketOnEvent(`new_market_added`, res => {
      if (res.status == true) {
       this.toastr.success(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
        this.homematches();
      }
    });
    this.socketOnEvent(`socket_state_changed`, res => {
      this.isSocket = res.is_socket
      this.route.params.subscribe(params => {
        if (params.sportName == undefined) {
          this.userData = {};
          this.homematches();
        } else {
          this.parameter = params.sportName;
          this.homematches();
        }
      })
      if (this.isSocket == 0) {
        this.marketId = [];
        for (let i = 0; i < this.firstData.length; i++) {
          this.marketId.push(this.firstData[i].marketId)
        }
        let event = {
          "eventIds": this.marketId
        }
        this.socketEmitEvent('unsubscribe_event', event);
      } else {
        clearTimeout(this.timer);
      }
    });
  }

  getHomeMatchCallEvent(param) {
    this.userData = {};
    this.socketEmitEvent('homeMatches', this.userData);
  }
  homematches() {
    this.sport.getHomeMatchesList(this.userData).subscribe(res => {
      if (res.status) {
          this.firstData = res.data;
          this.firstDataLength = this.firstData.length;
          // this.getAllSportsListData();
          if(this.firstData.length != 0){
          for (let i = 0; i < this.firstDataLength; i++) {
            this.firstData[i].manualInplay = this.firstData[i].inplay;
            if ((this.firstData[i].my_favorites).length != 0) {
              for (let j = 0; j < (this.firstData[i].my_favorites).length; j++) {
                let isFounded = (this.firstData[i].my_favorites).some(ai => ai === this.userDetail._id);
                if (isFounded == true) {
                  this.firstData[i].fav = true;
                } else {
                  this.firstData[i].fav = false
                }
              }
            } else {
              this.firstData[i].fav = false
            }
            this.updateRunnerData[i] = {
              "marketId": this.firstData[i].marketId,
              "status": "SUSPENDED",
              // "inplay": false,
              "runners": [
                {
                  "ex": {
                    "availableToBack": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "availableToLay": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "tradedVolume": []
                  }
                },
                {
                  "ex": {
                    "availableToBack": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "availableToLay": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "tradedVolume": []
                  }
                }
              ]
            }
          }
          // if (this.isSocket == 1) {
            let a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }));
            let matches;
            if (this.parameter == undefined || this.parameter == 'All') {
              matches = a3;
              this.dataLength = matches.length;
            } else if (this.parameter == 'inplay') {
              matches = a3.filter(t => t.inplay == true || t.manualInplay == true);
              this.dataLength = matches.length;
            } else {
              matches = a3.filter(t => t.sport_name == this.parameter);
              this.dataLength = matches.length;
            }
            matches = matches.sort((a: any, b: any) =>
              new Date(a.match_date).getTime() - new Date(b.match_date).getTime()
            );
            // matches = matches.reduce((groupSport, sports) => {
            //   const { sport_name } = sports;
            //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
            //   return groupSport;
            // }, {});
            this.homeData = matches;
            // Shuffle the array and pick the first 4 items
const getRandomItems = (arr, count) => {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

this.homeDataFav = getRandomItems(matches, 10);
        
              this.runners();
            this.cdRef.detectChanges();
          }else {
            this.toastr.error('No Match Found', '', {
              positionClass: 'toast-top-center',
              timeOut: 1000
            });
          }
          // } else {
          //   this.runners();
          // }
      } else {
        if (res.logout == true) {
          // this.head.logoutUser();
        } else {
          this.toastr.error(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
        }
      }
    }, (err) => {
      console.log(err);
    },
      () => {
        if (this.router.url.split('?')[0] == '/dashboard') {
          if (this.isSocket != 1) {
            this.timer = setTimeout(() => resolve(this.homematches()), 10000);
          } else {
            clearTimeout(this.timer);
          }
        }
      })
  }
  runners() {
    this.userData = {};
    this.sport.runnerList(this.userData).subscribe((res) => {
      if (res.status) {
        this.runnerDataLength = res.data.length;
        this.runnerData = res.data;
        for (let i = 0; i < (this.firstData).length; i++) {
          for (let j = 0; j < this.runnerDataLength; j++) {
            if (this.firstData[i].marketId == this.runnerData[j].marketId) {
              this.updateRunnerData[i] = []
              this.updateRunnerData[i] = (this.runnerData[j]);
              break
            } else {
              this.updateRunnerData[i] = {
                "marketId": this.firstData[i].marketId,
                "status": "SUSPENDED",
                "inplay": false,
                "runners": [
                  {
                    "ex": {
                      "availableToBack": [
                        {
                          "price": "--",
                          "size": "--"
                        }
                      ],
                      "availableToLay": [
                        {
                          "price": "--",
                          "size": "--"
                        }
                      ],
                      "tradedVolume": []
                    }
                  },
                  {
                    "ex": {
                      "availableToBack": [
                        {
                          "price": "--",
                          "size": "--"
                        }
                      ],
                      "availableToLay": [
                        {
                          "price": "--",
                          "size": "--"
                        }
                      ],
                      "tradedVolume": []
                    }
                  }
                ]
              }
            }
          }
        }
        const a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }))
        this.a = a3;
        let matches;
        if (this.parameter == undefined || this.parameter == 'All') {
          matches = this.a;
          this.dataLength = matches.length;
        } else if (this.parameter == 'inplay') {
          matches = this.a.filter(t => t.inplay == true || t.manualInplay == true);
          this.dataLength = matches.length;
        } else {
          matches = this.a.filter(t => t.sport_name == this.parameter);
          this.dataLength = matches.length;
        }
        matches = matches.sort((a: any, b: any) =>
          new Date(a.match_date).getTime() - new Date(b.match_date).getTime()
        );

        this.totalMatchLength = matches;
        // matches = matches.reduce((groupSport, sports) => {
        //   const { sport_name } = sports;
        //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
        //   return groupSport;
        // }, {});
        this.homeData = matches;
        this.a = [];
        this.cdRef.detectChanges();
        this.getRunnerEmit();
      } else {
        for (let i = 0; i < this.firstDataLength; i++) {
          this.updateRunnerData[i] = {
            "marketId": this.firstData[i].marketId,
            "status": "SUSPENDED",
            "inplay": false,
            "runners": [
              {
                "ex": {
                  "availableToBack": [
                    {
                      "price": "--",
                      "size": "--"
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": "--",
                      "size": "--"
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "ex": {
                  "availableToBack": [
                    {
                      "price": "--",
                      "size": "--"
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": "--",
                      "size": "--"
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          }
        }
        const a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }));
        this.a = a3;
        let matches;
        if (this.parameter == undefined || this.parameter == 'All') {
          matches = this.a;
          this.dataLength = matches.length;
        } else if (this.parameter == 'inplay') {
          matches = this.a.filter(t => t.inplay == true || t.manualInplay == true);
          this.dataLength = matches.length;
        } else {
          matches = this.a.filter(t => t.sport_name == this.parameter);
          this.dataLength = matches.length;
        }
        matches = matches.sort((a: any, b: any) =>
          new Date(a.match_date).getTime() - new Date(b.match_date).getTime()
        );

        // matches = matches.reduce((groupSport, sports) => {
        //   const { sport_name } = sports;
        //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
        //   return groupSport;
        // }, {});
        this.homeData = matches;
        this.a = [];
        this.cdRef.detectChanges();
        this.getRunnerEmit();
      }
    }, (err) => {
      console.log(err);
    })
  }
  scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 250), behavior: 'smooth' });
  }

  scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 250), behavior: 'smooth' });
  }
  getAllSportsListData() {
    let userData = {dashboard : true};
    this.sport.getAllSportsList(userData).subscribe(res => {
      this.allSportsList = res.data
      this.allSportsList = (this.allSportsList).sort(function (b, a) { return  b.sport_id - a.sport_id  });
      console.log(this.allSportsList)
    this.socketStatus();
    })
  }
  getAllSportsList() {
    let userData = {};
    this.sport.getAllSportsList(userData).subscribe(res => {
      let a = res.data
      let b = [];
      let c = [];
      let d;
      // this.mobileAllSportsList = (this.mobileAllSportsList).sort(function (b, a) { return  b.sport_id - a.sport_id  });
      for(let i = 0; i< a.length; i++){
        if(a[i].sport_id > 0){
          b.push(a[i])
          d = (b).sort(function (k, l) { return  k.sport_id - l.sport_id  });
        } else {
          c.push(a[i])
        }
      }
      let e = [
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "7",
          "providerCode": null,
          "name": "Horse Racing"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "10",
          "providerCode": null,
          "name": "Table Tennis"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "4339",
          "providerCode": null,
          "name": "Greyhound Racing"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "7522",
          "providerCode": null,
          "name": "Basketball"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "998917",
          "providerCode": null,
          "name": "Volleyball"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "7525",
          "providerCode": null,
          "name": "kabaddi"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "7524",
          "providerCode": null,
          "name": "Ice Hockey"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "7526",
          "providerCode": null,
          "name": "Fustal"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "27454571",
          "providerCode": null,
          "name": "EGames"
        },
        {
          "is_active": true,
          "is_live_sport": 0,
          "sport_id": "6422",
          "providerCode": null,
          "name": "Snooker"
        }
      ];
      // d.push(e);
      // // e.push(c)
      for(let i = 0;i < e.length;i++){
        d.push(e[i])
      }
      this.mobileAllSportsList = d;
      this.socketStatus();
    })
  }
  goToInplay(sportName) {
    this.router.navigate(['dashboard/' + sportName]);
  }

  goToDashboard(sportName, id, data) {
    if (id == -100) {
      this.router.navigate(['casino']);
    } else  if (id < -100) {
      this.router.navigate(['snova/' + id + '/' + data.name + '/' + data.providerCode])
    } else if(id > -100){
      this.router.navigate(['dashboard/' + sportName]);
    }else if (id == 'QT') {
      this.router.navigate(['qtech'])
    }
  }

  matchDetail(matchData) {
    localStorage.setItem('matchData', JSON.stringify(matchData));
    this.router.navigate(['match-detail']);
  }
  matchDetailDrop(matchData) {
    this.modalRef.hide();
    localStorage.setItem('matchData', JSON.stringify(matchData));
    this.router.navigate(['match-detail']);
  }
  goToAll(sportName) {
    this.router.navigate(['dashboard/' + sportName]);
  }
  dashboard() {
    this.router.navigate(['dashboard']);
  }
  gotoexchangeGame(cardData) {
    let data = {
      game_id : cardData.match_id
    }
 /*   this.sport.lotusLaunch(data).subscribe((res) => {
      if(res.status == true){
        // window.open(res.launchUrl, '_blank')
        this.iUrl = res.launchUrl;
        localStorage.setItem('casino',this.iUrl)
        this.router.navigate(['casino-detail'])
      }
    }) */
    localStorage.setItem('selectedMatch', JSON.stringify(cardData.match_id));
    this.router.navigate(['casino-detail/'+cardData.match_id]);
  }

  getNews() {
      let data = {};
      this.reportService.getNews(data).subscribe((res) => {
        if (res.status) {
          if (res.data == null) {
            this.adminHeading = '';
          } else {
            this.allData = res.data;
            this.adminData = this.allData.filter(t => t.user_type_id == 0);
            if (this.adminData.length != 0) {
              this.adminHeading = this.adminData[0].heading;
            }
          }
        }
      })
    }

    favourite(id){
      let data = {
        match_id: id
      };
      this.sport.favourite(data).subscribe((res) => {
        if(res.status == true) {
          this.toastr.success(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 1000
          });
          this.homematches();
        } else {
          this.toastr.error(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
        }
      })
    }
    openModalSearch(search: TemplateRef<any>) {
      this.modalRef = this.modalService.show(
        search,
        Object.assign({}, { class: 'searchModal',ignoreBackdropClick: true })
      );
    }
}
